import React from 'react'
import { Box } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import CustomButton from '../CustomButton'
import { setShowCopyLinkModal } from '../../slices/appSlice'

const CopyToClipboardButton = () => {
  const dispatch = useDispatch()
  const { shareableURL } = useSelector((state) => state.appSlice)

  const handleClick = () => {
    dispatch(setShowCopyLinkModal(true))
  }

  return (
    <Box
      sx={{
        position: 'absolute',

        zIndex: 1050,
        display: 'flex',
        width: '300px',
        justifyContent: 'center'
      }}
    >
      <CustomButton
        btnLabel="Save & Share Project Link"
        handleNext={handleClick}
        marginTop={1}
        showShareIcon={true}
        disabled={!!shareableURL}
      />
    </Box>
  )
}

export default CopyToClipboardButton
